jQuery(document).ready(function($) {

  let $loginForm = $('form.woocommerce-form-login'),
      $registerForm = $('form.woocommerce-form-register'),
      $updatePasswordForm = $('form#update-password'),
      $forgetPasswordForm = $('form#forget-password');

  $forgetPasswordForm.on('submit', function(e){

    e.preventDefault();

    $forgetPasswordForm.find('.error-message').remove();
    $forgetPasswordForm.find('button').prop('disabled', true);
    $forgetPasswordForm.find('button').html(trans.forget_password_progress + ' <i class="fas fa-spinner fa-spin"></i>');

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'custom-forget-password',
        'user_login': $forgetPasswordForm.find('#user_login').val(),
      }
    }).done( function (response) {
        $forgetPasswordForm.prepend('<div class="error-message">' + response.message + '</div>');
        $forgetPasswordForm.find('button').prop('disabled', false);
        $forgetPasswordForm.find('button').html(trans.reinitialize);
    });

  });

  $loginForm.on('submit', function(e){

    e.preventDefault();

    $loginForm.find('.error-message').remove();
    $loginForm.find('button').prop('disabled', true);
    $loginForm.find('button').html(trans.connexion_in_progress + ' <i class="fas fa-spinner fa-spin"></i>');

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'custom-login',
        'log': $loginForm.find('#username').val(),
        'pwd': $loginForm.find('#password').val(),
        'security': $loginForm.find('#woocommerce-login-nonce').val(),
        'open_session': $loginForm.find('#open_session').val()
      }
    }).done( function (response) {
      if (response.logged_in) {
        window.location.replace(response.redirect_url);
      } else {
        $loginForm.prepend('<div class="error-message">' + response.message + '</div>');
        $loginForm.find('button').prop('disabled', false);
        $loginForm.find('button').html(trans.register);

      }
    });

  });

  $registerForm.on('submit', function(e){
    e.preventDefault();

    $registerForm.find('.error-message').remove();
    $registerForm.find('button').prop('disabled', true);
    $registerForm.find('button').html(trans.register_in_progress + ' <i class="fas fa-spinner fa-spin"></i>');

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'custom-register',
        'email': $registerForm.find('#reg_email').val(),
        'pwd': $registerForm.find('#reg_password').val(),
        'confirm_pwd': $registerForm.find('#confirm_password').val(),
        'security': $registerForm.find('#woocommerce-register-nonce').val()
      }
    }).done( function (response) {
      if (!response.registered) {
        $registerForm.prepend('<div class="error-message">' + response.message + '</div>');
        $registerForm.find('button').prop('disabled', false);
        $registerForm.find('button').html(trans.register);
      } else {
        window.location.replace(response.redirect_url);
      }
    });
  });

  $updatePasswordForm.on('submit', function(e){
    e.preventDefault();

    $updatePasswordForm.find('.notice').remove();
    $updatePasswordForm.find('button').prop('disabled', true);
    $updatePasswordForm.find('button').append('<i class="fas fa-spinner fa-spin"></i>');

    $.ajax({
      url: urls.ajax,
      method: 'post',
      data: {
        'action': 'update-password',
        'old_password': $updatePasswordForm.find('#old_password').val(),
        'new_password': $updatePasswordForm.find('#new_password').val(),
        'repeat_new_password': $updatePasswordForm.find('#repeat_new_password').val()
      }
    }).done( function (response) {
      if (!response.is_error) {
        document.location.reload();
      } else {
        $updatePasswordForm.prepend('<div class="error-message notice">' + response.message + '</div>');
        $updatePasswordForm.find('button').prop('disabled', false);
        $updatePasswordForm.find('button i').remove();
      }
    });
  });

});
